import { defineStore } from "pinia";

interface SnackbarStore {
  snackbar: Snackbar;
}

export type SnackbarTarget = "main" | "pip";

export interface Snackbar {
  color: string;
  text: string;
  timeout: number;
  show?: boolean;
  target?: SnackbarTarget;
}

export const useSnackbarStore = defineStore("snackbarStore", {
  state: (): SnackbarStore => ({
    snackbar: {
      color: "",
      text: "",
      timeout: 0,
      target: "main",
    },
  }),
  actions: {
    showSnackbar(snackbar: Snackbar) {
      snackbar.show = true;
      snackbar.target = snackbar.target ?? "main";
      this.snackbar = snackbar;
    },
    closeSnackBar() {
      this.snackbar = { ...this.snackbar, show: false };
    },
    showSnackbarError(message: string, timeout = -1, target: SnackbarTarget = "main") {
      const snackbar = {
        color: "#FF5252",
        text: message,
        timeout: timeout,
        target,
      };
      this.showSnackbar(snackbar);
    },
    showSnackbarSuccess(message: string, target: SnackbarTarget = "main") {
      const snackbar = {
        color: "success",
        text: message,
        timeout: 4000,
        target,
      };
      this.showSnackbar(snackbar);
    },
  },
});
